import { render } from "./ZuWang.vue?vue&type=template&id=32b3a218&scoped=true"
import script from "./ZuWang.vue?vue&type=script&lang=js"
export * from "./ZuWang.vue?vue&type=script&lang=js"

import "./ZuWang.vue?vue&type=style&index=0&id=32b3a218&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b3a218"]])

export default __exports__